// extracted by mini-css-extract-plugin
export default {"activeKpi":"src-views-analytics-components-SpotlightKPI-SpotlightKPI__activeKpi--dXBqK","kpiTab":"src-views-analytics-components-SpotlightKPI-SpotlightKPI__kpiTab--BsQ2s"};